import { Buffer } from 'buffer';

/**
 * Must load before any `@ton/core` import — that package reads global Buffer at module init.
 * Use plain assignment (not ||=) so older mobile Safari can parse the bundle.
 */
const g = (typeof globalThis !== 'undefined' ? globalThis : window) as typeof globalThis & {
  Buffer?: typeof Buffer;
};
if (!g.Buffer) {
  g.Buffer = Buffer;
}
